export default __webpack_public_path__ + "static/media/settings.456af580.svg";